import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject, type OnDestroy } from '@angular/core';
import { PorscheDesignSystemModule, ToastManager } from '@porsche-design-system/components-angular';
import { BehaviorSubject, distinctUntilChanged, tap } from 'rxjs';
import { SubSink } from 'subsink';
import { AdminService } from '../../../services/api/admin.service';

@Component({
  selector: 'opa-add-monthly-income',
  imports: [CommonModule, PorscheDesignSystemModule],
  templateUrl: './add-monthly-income.component.html',
  styleUrl: './add-monthly-income.component.scss',
})
export class AddMonthlyIncomeComponent implements OnDestroy {
  private readonly adminService = inject(AdminService);
  private readonly toastManager = inject(ToastManager);

  @Input({ required: true }) open = false;
  @Output() dismiss = new EventEmitter<boolean | undefined>();

  private readonly subSink = new SubSink();
  private readonly submitting = new BehaviorSubject(false);
  readonly submitting$ = this.submitting.pipe(distinctUntilChanged());

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  close(success?: boolean): void {
    this.dismiss.emit(success);
  }

  submit(): void {
    this.submitting.next(true);

    this.subSink.sink = this.adminService
      .addMonthlyIncome()
      .pipe(
        tap({
          next: () => {
            this.toastManager.addMessage({
              text: `Monthly income added`,
              state: 'success',
            });
            this.submitting.next(false);
            this.close(true);
          },
          error: () => this.submitting.next(false),
        }),
      )
      .subscribe();
  }
}
